import React, { useState, useEffect } from "react";
import "./UserLeftSidebar.css";
import profile from "../assets/images/profile.png";
import LogoutIcon from '@mui/icons-material/Logout';
import { NavLink, useNavigate } from "react-router-dom";
 
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined"; 
import axios from "../../api/axios";
 
export default function UserLeftSidebar() {
  const [openSidebar, setOpenSidebar] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleProfileUpdate = () => {
      const userData = localStorage.getItem("user");
      if (userData) {
        setUser(JSON.parse(userData));
      }
    };

    handleProfileUpdate();
    window.addEventListener("user-profile-updated", handleProfileUpdate);
    return () => {
      window.removeEventListener("user-profile-updated", handleProfileUpdate);
    };
  }, []);

  const handleLogout = (e) => {
    if (e) e.preventDefault();
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    localStorage.removeItem("wishlist_slugs");
    window.dispatchEvent(new Event("user-profile-updated"));
    window.dispatchEvent(new Event("wishlist-slugs-updated"));
    axios.get("/auth/logout").catch(() => {});
    navigate("/login");
  };

  return (
    <div className='outerrrrr'>
      <div className="mobile-view-btn-text">
        <button className="menu-btn" onClick={() => setOpenSidebar(true)}>
          <MenuIcon/>
        </button>
        <div className='dashbord-header'>
          <div className='dropdown-section d-flex align-items-center'>
            <div className="dropdown">
              <button className="btn dropdown-toggle d-flex align-items-center gap-3" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                <div className='profile-name-mobile'>
                  <img src={user?.avatar_original || user?.avatar || profile} alt="Profile" />
                </div>
                <ExpandMoreIcon />
              </button>
 
              <ul className="dropdown-menu ">
                <li><NavLink className="dropdown-item" to="/profile">Profile</NavLink></li>
                <li><NavLink className="dropdown-item" to="/support">Support</NavLink></li>
                <li><button onClick={handleLogout} className="dropdown-item w-100 text-start border-0 bg-transparent">Logout</button></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
 
      <div className={`iner-dashbord-left ${openSidebar ? "active" : ""}`}>
        <button className="close-btn" onClick={() => setOpenSidebar(false)}>
          <CloseIcon/>
        </button>
        <div className='profile-name'>
          <img src={user?.avatar_original || user?.avatar || profile} alt="Profile" />
          <div className='name-mail'>
            <h4>{user?.name || "User"}</h4>
            <p>{user?.email || user?.phone || "Email/Phone"}</p>
          </div>
        </div>
 
        <div className='dashbord-list-section'>
          <ul>
            <li>
              <NavLink
                to="/dashboard"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <HomeOutlinedIcon /> Dashboard
              </NavLink>
            </li>
 
            <li>
              <NavLink
                to="/purchasehistory"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <LocalOfferOutlinedIcon /> Purchase History
              </NavLink>
            </li>
 
            <li>
              <NavLink
                to="/wishlist"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <FavoriteBorderOutlinedIcon />
                Wishlist
              </NavLink>
            </li>
 
            <li>
              <NavLink
                to="/orderlist"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <LocalMallOutlinedIcon />
                Orders
              </NavLink>
            </li>
 
            <li>
              <NavLink
                to="/profile"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <PersonOutlineOutlinedIcon /> Profile
              </NavLink>
            </li>
 
            <li>
              <NavLink
                to="/support"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <HeadsetMicOutlinedIcon /> Support
              </NavLink>
            </li>
 
            <li>
              <NavLink
                to="/manageaddress"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <LocationOnOutlinedIcon /> Manage Address
              </NavLink>
            </li>
          </ul>            
        </div>
 
        <div className='logout-btn' style={{ cursor: 'pointer' }} onClick={handleLogout}>
          <span>
            <LogoutIcon /> Logout
          </span>
        </div>
 
      </div>
    </div>
  );
}